import styled, { keyframes } from "styled-components";
import { useVotacao } from "../../contexts/VotacaoContext";
import { useToast } from "../../contexts/ToastContext"

import { formatCPF } from "../../Funcoes/FormatCPF"
import { useEffect, useState } from "react";

import { FaUser } from "react-icons/fa";
import { LuLoaderCircle } from "react-icons/lu";
import axios from "axios";
import { useParams } from "react-router-dom";

const spin = keyframes`
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
`
const Titulo = styled.p`
    margin: 0 auto 10px auto;
    font-size: 15px;
`
const InputContainer = styled.div`
    width: 100%;
    height: 45px;
    border-radius: 12px;
    box-sizing: border-box;
    border: 1.8px solid rgba( 0, 0, 0, 0.4 );
    display: flex;
`
const IconeContainer = styled.div`
    height: 100%;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Icone = styled(FaUser)`
    color: rgba(0, 0, 0, 0.5);
    font-size: 18px;
`
const Input = styled.input`
    border: none;
    outline: none;
    flex: 1;
    height: 100%;
    font-size: 14px;
    background: transparent;
`
const LoadContainer = styled.div`
    height: 100%;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
`
const IconeLoad = styled(LuLoaderCircle)`
    color: rgba(0, 0, 0, 0.5);
    font-size: 25px;
    animation: ${spin} 1s linear infinite;
`
const ContainerAdvance = styled.div`
    width: 100%;
    height: 45px;
    display: flex;
    margin-top: 15px;
`
const Botao = styled.button`
    width: 200px;
    height: 45px;
    background-color: ${({ canClick }) => (canClick ? "#326fec" : "#ededed")};
    color: ${({ canClick }) => (canClick ? "#fff" : "#b0b0b0")};
    margin-left: auto;
    border-radius: 12px;
    border: none;
    transition: .2s;
    cursor: ${({ canClick }) => ( canClick ? "pointer" : "auto" )};
`
const NomeUser = styled.p`
    font-size: 14px;
    margin: auto 0;
`

const SelectUser = () => {

    const { cc, ano } = useParams();
    const { cpf, setCpf, setValidUser } = useVotacao();
    const { notifyError } = useToast();

    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState('');
    const [canVote, setCanVote] = useState(false);

    const verifyUser = async () => {

        if (cpf.length !== 14) return;

        setLoading(true);

        try {

            let valorCpf = cpf.replace(/\D/g, '')
            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Cipa/CheckUserCpf/', {
                'cpf': valorCpf,
                'centro_custo': cc,
                'ano': ano
            })

            console.log(data);
            setUser(data.NOME);
            setCanVote(true);

        } catch (e) {

            notifyError("Nenhum colaborador encontrado!");
            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        if (cpf.length === 14) {

            verifyUser()

        } else {

            setLoading(false);
            setUser('')
            setCanVote(false);

        }

        console.log(cpf);

    }, [cpf])

    const navVote = () => {

        if( !canVote ) return;
        setValidUser( true );

    }

    return (
        <>
            <Container>
                <Titulo>DIGITE SEU CPF:</Titulo>
                <InputContainer>
                    <IconeContainer>
                        <Icone />
                    </IconeContainer>
                    <Input
                        type="text"
                        placeholder="Digite seu CPF"
                        value={formatCPF(cpf)}
                        onChange={(e) => setCpf(e.target.value)}
                        maxLength={14}
                    />
                    <LoadContainer>
                        {loading && <IconeLoad />}
                    </LoadContainer>
                </InputContainer>
                <ContainerAdvance>
                    <NomeUser>{user}</NomeUser>
                    <Botao canClick={canVote} onClick={ navVote } >
                        AVANÇAR
                    </Botao>
                </ContainerAdvance>
            </Container>
        </>
    )
}

export default SelectUser;